import { ImageBlockSpec } from '@blocksuite/hive/blocks/image';
import { ToolbarModuleExtension } from '@blocksuite/hive/shared/services';
import { BlockFlavourIdentifier } from '@blocksuite/hive/std';
import type { ExtensionType } from '@blocksuite/hive/store';

import { imageToolbarAIEntryConfig } from '../entries/image-toolbar/setup-image-toolbar';

export const AIImageBlockSpec: ExtensionType[] = [
  ...ImageBlockSpec,
  ToolbarModuleExtension({
    id: BlockFlavourIdentifier('custom:hive:image'),
    config: imageToolbarAIEntryConfig(),
  }),
];
